export default __webpack_public_path__ + "static/media/notification.1e61b3a0.mp3";